<div class="reale-theme-style2" fxLayout="column" fxLayoutGap="1rem" *ngIf="coverageList?.length">
    <div class="exit-modal">
        <button class="button-close-container" mat-icon-button [mat-dialog-close]="true" >
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <div class="title-container">
        <span class="title" [innerHTML]="title | safeHtml"></span>
    </div>
    <div class='description-container' *ngIf="description" [innerHtml]="description | safeHtml">
    </div>
    <div class="infoicon-container">
        <app-icon-information *ngFor="let coverage of coverageList" [icon]="coverage.imagen || coverage.icono" [title]='coverage.alias' [subtitle]="coverage.descripcion">
        </app-icon-information>
    </div>

    <div class="coverage-container" *ngIf="coverageDetails">
      <!-- <p><strong>{{ 'sales.coverageList.details.dudas' | translate }}</strong></p> -->
      <div *ngFor="let cov of coverageDetails">
        <app-dropdown-info [title]="cov.title" [paragraphs]="cov.descripcion" (onClick)="openCoverageDetails(cov.title)" (onLinkClick)="handleDropdownLinkClick($event)">
        </app-dropdown-info>
      </div>
      <div class="mobile-bottom-spacer"></div>
    </div>
</div>
